export enum TokenSortMethod {
  Pool = 'Pool',
  Earned = 'Earned',
  APR = 'APR',
  TVL = 'TVL',
  Stake = 'Stake',
  operation = 'operation',
}
